
import { Report } from "interfaces/report"
import { ReportActionType } from "../action-types/reportTypes"
import { Action } from "../actions/reportActions"
import { PaginatedModel } from "interfaces/pagination"

interface IReports {
    reports: PaginatedModel<Report>
    lastReports: Report[]
}

const initialState: IReports = {
    reports: {
        paginatorInfo: {
            currentPage: 1,
            lastPage: 1,
            perPage: 30,
            total: 0
        },
        data: []
    },
    lastReports: [
    ]
}

const reducer = (state: IReports = initialState, action: Action) => {
    switch (action.type) {
        // case ReportActionType.LIST:
        //     return {
        //         ...state,
        //         reports: action.payload
        //     }
        case ReportActionType.LIST_LAST:
            return {
                ...state,
                lastReports: action.payload
            }
        case ReportActionType.PAGINATE:
            return {
                ...state,
                reports: action.payload
            }
        case ReportActionType.CREATE:
            return {
                ...state,
                reports: {
                    data: [action.payload, ...state.reports.data],
                    paginatorInfo: state.reports.paginatorInfo,
                },
                lastReports: [action.payload, ...state.lastReports]
            }
        case ReportActionType.UPDATE:
            return {
                ...state,
                reports: {
                    ...state.reports,
                    data: state.reports.data.map(rep => {
                        if (rep.id === action.payload.id) rep = action.payload
                        return rep
                    })
                },
                lastReports: state.lastReports.map(rep => {
                    if (rep.id === action.payload.id) rep = action.payload
                    return rep
                }),
            }
        default:
            return state
    }
}

export default reducer